/**
 * Helper function to check if we are in e2e mode or not.
 *
 * This is used in our form inputs where necessary, as we do not want to debounce
 * the input in cypress tests, so the tests are not as flaky and we do not have
 * to wait for 500 ms or something for the input to propagate.
 */
export function isE2e() {
    return Boolean(window.Cypress);
}
